import styled, { css } from 'styled-components';
import Image from 'next/image';
import {
  typography,
  breakpoints,
  spacing,
  universe,
  Card as FlareCard,
  Typography,
} from '@bitsoex/react-design-system/foundations';

export const BusinessHeroContainer = styled.section`
  padding: ${spacing.size14} ${spacing.size05} ${spacing.size11} ${spacing.size05};
  position: relative;
  overflow: hidden;

  > div:first-child > div:first-child {
    position: relative;
    z-index: 1;
    max-width: 100%;
    margin: 0 auto;
    text-align: left;

    small {
      svg {
        width: 16px;
        height: 20px;
      }
    }

    h1 {
      ${typography.titleLarge};
    }
  }

  a {
    width: 100%;
    max-width: 100%;
  }

  @media (min-width: ${breakpoints.tabletSmall}) {
    padding: 128px ${spacing.size07};

    > div:first-child > div:first-child {
      max-width: 952px;
      margin: 0 auto;
      text-align: center;

      h1 {
        ${typography.display}
      }
    }

    a {
      width: fit-content;
    }
  }
`;

export const BusinessMainHeroContainer = styled.section`
  padding: ${spacing.size14} ${spacing.size05} ${spacing.size11} ${spacing.size05};
  position: relative;
  background-image: url('/images/business/home/world.png'), radial-gradient(#fefffe 40%, #cffac2 100%);
  background-position: center 100px, center center;
  background-repeat: no-repeat, no-repeat;
  overflow: hidden;

  > div:first-child > div:first-child {
    position: relative;
    z-index: 1;
    max-width: 100%;
    margin: 0 auto;

    small {
      svg {
        width: 16px;
        height: 20px;
      }
    }
  }

  @media (min-width: ${breakpoints.tabletSmall}) {
    padding: 200px ${spacing.size07} 128px ${spacing.size07};
    background-position: center 140px, center center;

    > div:first-child > div:first-child {
      max-width: 952px;
      margin: 0 auto;
      h1 {
        ${typography.display};
      }
    }
  }
`;

export const HeroAction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: ${spacing.size07};

  a {
    width: 100%;
  }

  a:first-child {
    max-width: 100%;
  }

  @media (min-width: ${breakpoints.tabletSmall}) {
    flex-direction: row;
    justify-content: center;
    gap: ${spacing.size07};

    a {
      max-width: fit-content;
    }

    a:first-child {
      max-width: fit-content;
    }
  }
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  margin: ${spacing.size12} 0 0;
  gap: 33px;

  @media (max-width: ${breakpoints.desktopSmall}) {
    grid-template-columns: 1fr;
    justify-items: center;
    height: fit-content;
    padding: ${spacing.size05} 0;
    gap: ${spacing.size05};
  }
`;
export const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${universe.borealis10};
  border: 1px solid ${universe.borealis20};
  border-radius: 8px;
  margin: 0 ${spacing.size06} 0 0;

  svg {
    color: ${universe.borealis60};
  }
`;

export const Card = styled(FlareCard)`
  min-height: 132px;
  display: flex;
  border-radius: 2px;
  text-align: center;
  padding: ${spacing.size06};
  align-items: center;
  margin: 0;
  box-shadow: 0px 4px 16px 0px #0000001a;
  text-align: left;

  @media (max-width: ${breakpoints.desktopSmall}) {
    min-height: 80px;
    width: 100%;
    max-width: 328px;
    margin: 0 0 ${spacing.size05};
  }
`;

export const SolutionsContainer = styled.div`
  padding-bottom: ${spacing.size11};
  background-color: #fafafc;
  & img {
    width: 100%;
    object-fit: contain;
  }
  @media screen and (min-width: ${breakpoints.desktopSmall}) {
    padding-bottom: 128px;
    width: 100%;
  }
`;

export const StyledRoot = styled.div`
  padding: ${spacing.size11} 0px;
  & img {
    width: 100%;
    object-fit: contain;
  }
  & > div {
    display: flex;
    flex-direction: column;
  }

  @media screen and (min-width: ${breakpoints.tabletSmall}) {
    padding-bottom: 128px 0px;
  }

  @media screen and (min-width: ${breakpoints.desktopSmall}) {
    width: 100%;
    & img {
      width: 100%;
      height: auto;
    }
    & > div {
      display: flex;
      flex-direction: row;
    }
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.size05};

  @media (min-width: ${breakpoints.tabletSmall}) {
    flex-direction: column;
  }
  @media (min-width: ${breakpoints.desktopMedium}) {
    flex-direction: row;
  }
`;

export const TagContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 40px;
  flex-direction: column;
  div {
    margin-top: ${spacing.size04};
  }
  @media (min-width: ${breakpoints.tabletSmall}) {
    display: -webkit-box;
    div {
      margin-right: ${spacing.size04};
    }
  }
`;

export const ContactFormSection = styled.section`
  background-color: ${universe.moonlight20};
  padding: ${spacing.size11} ${spacing.size05};
  @media (min-width: ${breakpoints.desktopSmall}) {
    padding: ${spacing.size14} 281px;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.size10};
`;

export const SecurityContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: ${spacing.size07};
  margin: 0 auto ${spacing.size07};
  max-width: 952px;

  @media (min-width: ${breakpoints.mobileLarge}) {
    margin: 0 auto ${spacing.size11};
  }
`;

export const SecurityRegulatoryHeading = styled(Typography)`
  display: none;
  @media (min-width: ${breakpoints.mobileLarge}) {
    display: block;
    margin-bottom: ${spacing.size11};
  }
`;

export const FlagsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  justify-items: center;
  @media (min-width: ${breakpoints.desktopSmall}) {
    justify-items: baseline;
    grid-template-columns: repeat(5, 1fr);
  }
`;

export const StyledCard = styled.div`
  display: grid;
  background-color: ${universe.moonlight20};
  border-radius: 8px;
  padding: ${spacing.size07} ${spacing.size08};
  gap: ${spacing.size05};
`;

export const FlagContainer = styled.button<{ $active?: boolean }>`
  max-width: 90px;
  background: transparent;
  justify-content: center;
  align-items: center;
  display: grid;
  border-radius: ${spacing.size03};
  border: 0px none transparent;
  ${props =>
    props.$active &&
    css`
      border: 1px solid ${universe.moonlight30};
      background: ${universe.moonlight0};
      box-shadow: 0px 0px 15px ${universe.moonlight40};
    `}
  &:hover {
    border: 1px solid ${universe.moonlight30};
  }
`;

export const RootContainer = styled.section`
  padding: ${spacing.size11} 0px;
  background-color: #fafafc;
  @media (min-width: ${breakpoints.desktopSmall}) {
    padding: 128px 0px;
  }
`;

export const HowItWorksTitle = styled.div`
  padding: 0 0 ${spacing.size11};
  text-align: center;

  @media (min-width: ${breakpoints.desktopSmall}) {
    padding: 0 0 112px;
  }
`;
export const HowItWorksContainer = styled.div`
  display: grid;
  gap: ${spacing.size07};
  padding-bottom: ${spacing.size11};

  @media (min-width: ${breakpoints.desktopSmall}) {
    gap: ${spacing.size11};
    padding-bottom: 112px;
  }
`;
export const HowItWorksImageContainer = styled.div`
  background-color: ${universe.moonlight20};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 100%;
  border-radius: 16px;
  padding: 0;
  min-height: 541px;
  & img {
    width: 100%;
    object-fit: contain;
  }
  @media (min-width: ${breakpoints.desktopSmall}) {
    padding: ${spacing.size08};
  }
`;

export const HowItWorksCardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  gap: 40px;

  @media (max-width: ${breakpoints.desktopSmall}) {
    grid-template-columns: 1fr;
    justify-items: center;
    height: fit-content;
    padding: ${spacing.size05} 0;
    gap: ${spacing.size05};
  }
`;

export const TitleContainer = styled.div`
  padding: ${spacing.size11} 0px;
  text-align: center;
  @media (min-width: ${breakpoints.desktopSmall}) {
    padding: 128px 0px ${spacing.size12} 0px;
  }
`;

export const SectionWrapper = styled.div`
  border-bottom: 1px solid ${universe.moonlight30};
`;

export const SolutionsMainTitle = styled(Typography)`
  grid-column: 2;
  text-align: center;
  @media (min-width: ${breakpoints.desktopSmall}) {
    margin-bottom: ${spacing.size07};
  }
`;

export const CustomersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.size08};
  align-items: center;
  justify-content: flex-start;
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  padding: ${spacing.size08} ${spacing.size05};
  text-align: center;

  @media (min-width: ${breakpoints.desktopSmall}) {
    padding: 128px 156px;
    gap: ${spacing.size12};
  }
`;

export const CustomersPhotosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-gap: 40px 80px;

  @media (max-width: ${breakpoints.desktopSmall}) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
`;

export const ImageCont = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 248px;
`;

export const MainContainer = styled.section`
  background-color: #fafafc;
`;

export const SplitPanelContainer = styled.div<{ reverse?: boolean }>`
  display: flex;
  flex-direction: ${props => (props.reverse ? 'column-reverse' : 'column')};
  gap: ${spacing.size08};

  @media (min-width: ${breakpoints.tabletSmall}) {
    flex-direction: row;
  }
`;

export const ImagePanel = styled.div`
  width: 100%;
  position: relative;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${spacing.size05};
  img {
    border-radius: ${spacing.size05};
  }
  @media (min-width: ${breakpoints.tabletSmall}) {
    height: unset;
  }
`;

export const ContentPanel = styled.div`
  width: 100%;
  @media (min-width: ${breakpoints.tabletLarge}) {
    max-width: 544px;
  }
`;

export const SeeMoreContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  gap: ${spacing.size09};
  @media (min-width: ${breakpoints.desktopSmall}) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: unset;
  }
`;

export const SeeMoreCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const StyledHeading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  margin-bottom: ${spacing.size11};
  @media (min-width: ${breakpoints.desktopSmall}) {
    margin-bottom: ${spacing.size12};
    text-align: center;
  }
`;

export const StyledTypography = styled(Typography)`
  font-size: 20px;
  @media (min-width: ${breakpoints.desktopSmall}) {
    font-size: 1.25rem;
  }
`;

export const TransformativeSolutionsMainContainer = styled.section`
  border-top: 1px solid #d1d8df;
  padding: ${spacing.size11} ${spacing.size05};
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: ${breakpoints.desktopSmall}) {
    padding: 128px 156px;
  }
`;

export const TransformativeSolutionsContainer = styled.div`
  & img {
    width: 100%;
    object-fit: contain;
  }

  @media screen and (min-width: ${breakpoints.desktopSmall}) {
    width: 100%;
    max-width: 1512px;

    > div {
      justify-content: space-evenly;
      gap: ${spacing.size06};
      > div {
        max-width: 580px;
        align-content: center;
      }
    }
  }
`;
